<ion-card (keydown.enter)="onCallback()" role="button" (click)="onCallback()" tabindex="0" style="cursor: pointer;">
  <ion-item style="--background: var(--ion-background-color-card-header)" lines="full">
    <!-- color="light" -->

    <!-- Check if img or icon is handed over. -->
    @if (img) {
      <ion-avatar slot="start" [class]="'iconify' + (img.large? ' icon-large' : '')">
        <img [src]="img.src">
      </ion-avatar>
    }
    @if (icon) {
      <ion-icon slot="start" [size]="icon.size || 'large'" [color]="icon.color || 'primary'"
        [name]="icon.name">
      </ion-icon>
    }

    <!-- Check which title type is handed over. -->
    @if (title) {
      <ion-label>{{ title }}</ion-label>
    }

    <ng-content select="[button]"></ng-content>
  </ion-item>

  <ion-card-content style="--background: var(--ion-color-primary)">
    <ng-content></ng-content>
  </ion-card-content>
</ion-card>
